import registracionLib from '@ln/registracionlibs';

(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (View, Helper, Service, Model, Config, Controller, Hotjar, SWG) {
  'use strict';

  View.wall = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('WALL', {
        Error: error
      }, function () {
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
        Helper.eventosInicioWall();
        Helper.trackPaywallView();
        registracionLib.init();
        GoogleSubscribe.start(function () {
          Helper.BtnGoogle();
        });
        LN.Wcentrix && LN.Wcentrix.initChat();
        Hotjar.callTrigger(Config.HotjarHeatmapWall);
      });
    })
  }

  View.wallSuscribime = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      console.log('call-wsusc');
      Helper.callView('WALL_SUSCRIBIME', {
        Error: error
      }, function () {
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
        Helper.eventosInicioSuscribirme();
        registracionLib.init();
        GoogleSubscribe.start(function () {
          Helper.BtnGoogle();
        });
        LN.Wcentrix && LN.Wcentrix.initChat();
      });
    })
  }

  View.wallDinamico = function (error) {
    console.log('/landings/' + Model.Window.landingUrl);
    Service.landingObtener(
      Model.Window.landingUrl, function (res, status, xhr) {
        Helper.callView('WALL_DINAMICO', {
          Error: error
        }, function () {
          Helper.eventosInicio();
          Helper.setIframeHeight();
          Helper.eventosInicioSuscribirme();
          LN.Wcentrix && LN.Wcentrix.initChat();
        });
      })
  }

  View.procesarPago = function (error) {
    Helper.callView('PROCESAR_PAGO', {
      Error: error
    }, function () {

    });
  }

  View.pdfSuscriptoSinAcceso = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('PDF_SUSCRIPTO_SIN_ACCESO', {
        Error: error
      }, function () {
        //        Helper.eventosInicio();
      });
    })
  }

  View.pdfSinSuscripcion = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('PDF_SIN_SUSCRIPCION', {
        Error: error
      }, function () {
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
      });
    })
  }

  View.ingresarDni = function (error) {
    Helper.callView('INGRESAR_DNI', {
      Error: error
    }, function () {
      //Model.Window.lastFlow = "";                 // Limpio el ultimo flow ejecutado
      //Helper.eventosInicioIngresarDNI();
      //Helper.carrito();
      //Hotjar.callTrigger(Config.HotjarHeatmapFormDocumento);
    });
  }

  View.formularioDatosPersonales = function (error) {
    Helper.callView('FORMULARIO_DATOS_PERSONALES', {
      Error: error
    }, function () {
      Model.Window.lastFlow = "";
      Helper.eventosInputIngresarDocumento('datos_personales[numeroDocumento]');
      Helper.eventosDatosPersonales();
      Helper.carrito();
      Hotjar.callTrigger(Config.HotjarHeatmapFormPersonales);
    });
  }

  View.formularioPosdatado = function (error, cb) {
    Helper.callView(
      'FORMULARIO_ENVIO',
      { Error: error },
      function () {
        Hotjar.callTrigger(Config.HotjarHeatmapFormDomicilio);
        cb && cb();
      }
    );
  }

  View.formularioEnvio = function () {
    /*Ya tengo los datos de dom cargados del paso anterior*/
    Controller.obtenerDatosPersonalesFormularioEnvio();
  }

  View.formularioPago = function (error, hideForm) {
    Helper.callView('FORMULARIO_PAGO', {
      Error: error,
      Pago: Model.Venta.Pago,
      HideForm: hideForm
    }, function () {
      Helper.eventosPago();
      Helper.setIframeHeight();
      Helper.carrito();
      Hotjar.callTrigger(Config.HotjarHeatmapFormPago);
    }, true);
  }

  View.confirmacionCombo1 = function (error) {
    Helper.callView('CONFIRMACION_COMBO_1', {
      Error: error
    }, function () {
      LN.AppEvent.sendEvent('FLOW_OK');
      //
    });
  }

  View.confirmacionCombo2 = function (error) {
    Helper.callView('CONFIRMACION_COMBO_2', {
      Error: error
    }, function () {
      LN.AppEvent.sendEvent('FLOW_OK');
      //
    });
  }

  View.faltaDePago = function (error) {
    Helper.callView('FALTA_DE_PAGO', {
      Error: error
    }, function () {
      //
    });
  }

  View.yaTieneCuenta = function (error) {
    Helper.callView('YA_TIENE_CUENTA', {
      Error: error
    }, function () {
      /* hardcoding de prueba*/
      /*const FacebookIA = new Promise(Controller.FbInstantArticlesVentaPromise);
      FacebookIA.then(() => {
          if (Model.Embed.Article === true && Model.Embed.Name === "FacebookInstantArticles") {
              Helper.resetImg('externalPaywallToken', Model.ExternalPaywall.AutorizationToken, () => {
                  console.log('resolve externalPaywallToken');
              })
          }
      })*/
      LN.AppEvent.sendEvent('FLOW_OK');
      LN.AppEvent.sendEvent('VENTA-OK');
      $("body").addClass("custom-bg-mobile");     // Agrego class para que levanta el background-image
    }, true);
  }

  View.primerAcceso = function (error) {
    Helper.callView('PRIMER_ACCESO', {
      Error: error
    }, function () {


      LN.AppEvent.sendEvent('FLOW_OK');
      LN.AppEvent.sendEvent('VENTA-OK');
      Model.Window.lastFlow = "";                 // Limpio el ultimo flow ejecutado
      $("body").addClass("custom-bg-mobile");     // Agrego class para que levanta el background-image
    }, true);
  }

  View.planInsuficiente = function (error) {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('PLAN_INSUFICIENTE', {
        Error: error,
        ClubNacion: Model.Me.Usuario.ClubNacion || Helper.readCookie('usuarioDetalleClubNacion')
      }, function () {
        Model.Window.lastFlow = "";                 // Limpio el ultimo flow ejecutado
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
        registracionLib.init();
        GoogleSubscribe.start(function () {
          Helper.BtnGoogle();
        });
        LN.AppEvent.sendEvent('PLAN-INSUFICENTE');
      });
    })
  }

  View.tieneDeuda = function (error) {
    Helper.callView('TIENE_DEUDA', {
      Error: error
    }, function () {
      Model.Window.lastFlow = "";                 // Limpio el ultimo flow ejecutado
      LN.AppEvent.sendEvent('TIENE_DEUDA');
    });
  }

  View.domicilioNoExiste = function (error) {
    Helper.callView('DOMICILIO_NO_EXISTE', {
      Error: error
    }, function () {
      //
    });
  }

  View.yaCompro = function () {
    Helper.callView('YA_COMPRO', null, function () {
      LN.AppEvent.sendEvent('FLOW_OK');
      LN.AppEvent.sendEvent('VENTA-OK');
      Model.Window.lastFlow = "";                 // Limpio el ultimo flow ejecutado
    });
  }

  View.noTieneSuscripcion = function () {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('NO_TIENE_SUSCRIPCION', null, function () {
        Helper.eventosInicio();
        Helper.eventosInicioMuroNuevo();
        Helper.trackPaywallView();
        registracionLib.init();
        GoogleSubscribe.start(function () {
          Helper.BtnGoogle();
        });
        LN.Wcentrix && LN.Wcentrix.initChat();
        Hotjar.callTrigger(Config.HotjarHeatmapWall);
      });
    })
  }

  View.landing = function () {
    Service.campanaObtener(Config.campaniaPaga, function (res, status, xhr) {
      Helper.callView('LANDING', null, function () {
        Helper.eventosLanding();
        Helper.eventosInicio();
      });
    })
  }

  View.validarPin = function (error, cb) {
    Helper.callView('VALIDAR_PINES', {
      Error: error
    }, function () {
      LN.Wcentrix && LN.Wcentrix.initChat();
      // do something
      cb && cb();
    }, true);
  }

  View.validarPinGracias = function (error) {
    Helper.callView('VALIDAR_PINES_GRACIAS', {
      Error: error
    },
      function () {
        // do something
      });
  }

  View.asociarTarjeta = function (error, tipoError, cb) {
    Helper.callView('ASOCIAR_TARJETA', {
      Code: Model.Usuario.TipoAsociarCredencial,
      Unico: Model.Usuario.Credenciales.length == 1,
      Error: error,
      TipoError: tipoError
    }, function () {
      Helper.asociarCredencialBindings();
      cb && cb();
    }, true);
  }

  View.mostrarMensajeTribuno = function (error) {
    Helper.callView('MOSTRAR_TRIBUNO', {
      Error: error
    }, function () {
      LN.AppEvent.sendEvent('PLAN-INSUFICENTE');
    });
  }

  View.mostrarMensajeUno = function (error) {
    Helper.callView('MOSTRAR_UNO', {
      Error: error
    }, function () {
      LN.AppEvent.sendEvent('PLAN-INSUFICENTE');
    });
  }

  View.yaTieneCuentaFacebook = function (error) {
    Helper.callView('YA_TIENE_FACEBOOK', {
      Error: error
    });
  }

  View.confirmacionBonificadoFacebook = function (error) {
    Helper.callView('CONFIRMACION_BONIFICADO_FACEBOOK', {
      Error: error
    });
  }


})(LN.View, LN.Helper, LN.Service, LN.Model, LN.Config, LN.Controller, LN.Hotjar, LN.SWG);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/paywallView.js